/**
 * StepIndicator — Shared progress bar for activation flows (Path A & Path B).
 *
 * Props:
 *   steps:           Array<{ key: string, label: string }> — ordered step definitions
 *   currentStep:     string — the key of the currently active step
 *   progressPercent: number (optional) — explicit percentage override.
 *                    If omitted, falls back to proportional calculation from step index.
 */

import React from 'react';

// Aurora gradient animation (injected once at module load)
const initializeAuroraStyles = () => {
  if (typeof document !== 'undefined') {
    const styleId = 'step-indicator-aurora-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        @keyframes stepIndicatorAurora {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `;
      document.head.appendChild(style);
    }
  }
};

// Initialize styles immediately (module load, not render)
initializeAuroraStyles();

export default function StepIndicator({ steps, currentStep, progressPercent }) {
  const resolved =
    progressPercent != null
      ? progressPercent
      : steps.length > 0
      ? ((steps.findIndex((s) => s.key === currentStep) + 1) / steps.length) * 100
      : 0;

  return (
    <div className="w-full h-1.5 bg-paper-inset rounded-full overflow-hidden mb-6">
      <div
        className="relative h-full rounded-full transition-[width] duration-[600ms] ease-in-out"
        style={{
          width: `${resolved}%`,
          background: 'linear-gradient(90deg, #5B785B, #6B8E6B, #7FA87F, #6B8E6B, #5B785B)',
          backgroundSize: '300% 100%',
          animation: 'stepIndicatorAurora 4s ease-in-out infinite',
        }}
      />
    </div>
  );
}
